import KanbanTaskCard from "@/features/tasks/components/KanbanTaskCard";
import { EmptyState } from "@/shared/components";
import { BOARD_PAGE_ROUTE } from "@/shared/utils";
import type { RecentTask } from "../../../types";
import SectionCard from "./SectionCard";

interface RecentTasksSectionProps {
  tasks: RecentTask[];
  projectId: number;
  projectName: string;
  t: (key: string) => string;
  onTaskClick?: (task: RecentTask) => void;
}

export default function RecentTasksSection({ tasks, projectId, projectName, t, onTaskClick }: RecentTasksSectionProps) {
  const boardLink = `${BOARD_PAGE_ROUTE}?project=${projectId}`;
  return (
    <SectionCard title={t("detail.taskManagement")} subtitle={t("detail.recentTasks")} link={boardLink}>
      {tasks.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {tasks.map((task) => (
            <KanbanTaskCard
              key={task.id}
              task={task}
              projectName={projectName}
              isDragOverlay={true}
              onTaskClick={onTaskClick}
            />
          ))}
        </div>
      ) : (
        <EmptyState
          compact
          noDataText={t("detail.recentTasksEmpty")}
          noDataHint={t("detail.recentTasksEmptyHint")}
        />
      )}
    </SectionCard>
  );
}
